import request from '@/plugin/axios'

export function ListSites (data) {
  return request({
    url: '/site/index',
    method: 'get',
    params: data
  })
}

export function ViewSite (id) {
  return request({
    url: '/site/view?id=' + id,
    method: 'get'
  })
}

export function CreateSite (data) {
  return request({
    url: '/site/create',
    method: 'post',
    data
  })
}

export function UpdateSite (data) {
  return request({
    url: '/site/update?id=' + data.id,
    method: 'post',
    data
  })
}

export function DeleteSite (id) {
  return request({
    url: '/site/delete?id=' + id,
    method: 'delete'
  })
}
